import axiosInstance from "../../services/AxiosInstance"

// Action Types
export const GET_PROFILE_REQUEST = "GET_PROFILE_REQUEST"
export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS"
export const GET_PROFILE_FAILURE = "GET_PROFILE_FAILURE"

export const UPDATE_PROFILE_REQUEST = "UPDATE_PROFILE_REQUEST"
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS"
export const UPDATE_PROFILE_FAILURE = "UPDATE_PROFILE_FAILURE"

// Get Profile Action
export const getAppProfile = () => {
  return async (dispatch) => {
    dispatch({ type: GET_PROFILE_REQUEST })

    try {
      const response = await axiosInstance.post("/admin/getProfile", {})

      console.log("API Response:", response.data) // Debug log

      dispatch({
        type: GET_PROFILE_SUCCESS,
        payload: response.data.data,
      })

      return response.data
    } catch (error) {
      console.error("Get Profile Error:", error) // Debug log

      dispatch({
        type: GET_PROFILE_FAILURE,
        payload: error.response?.data?.message || error.message || "Failed to fetch profile",
      })

      throw error
    }
  }
}

// Update Profile Action
export const updateProfile = (profileData) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_PROFILE_REQUEST })

    try {
      console.log("Updating profile with data:", profileData) // Debug log

      const response = await axiosInstance.post("/admin/updateProfile", {
        name: profileData.name,
        email: profileData.email,
        mobile: profileData.mobile,
        username: profileData.username,
        role_id: profileData.role_id || "", // Add role_id if needed
      })

      console.log("Update Response:", response.data) // Debug log

      dispatch({
        type: UPDATE_PROFILE_SUCCESS,
        payload: {
          name: profileData.name,
          email: profileData.email,
          mobile: profileData.mobile,
          username: profileData.username,
        },
      })

      return response.data
    } catch (error) {
      console.error("Update Profile Error:", error) // Debug log

      dispatch({
        type: UPDATE_PROFILE_FAILURE,
        payload: error.response?.data?.message || error.message || "Failed to update profile",
      })

      throw error
    }
  }
}
